const LOGOS = [
  { name: "Greedo", src: "/assets/brands/greedo.jpg" },
  { name: "BAO Bangalore", src: "/assets/brands/bao-bangalore.jpg" },
  { name: "The Healthy Füd", src: "/assets/brands/the-healthy-fud.jpg" },
  { name: "Kochi Kurry Klub", src: "/assets/brands/kochi-kurry-klub.jpg" },
  { name: "Malabar Flavors", src: "/assets/brands/malabar-flavors.jpg" },
  { name: "Swanky Spoon Society", src: "/assets/brands/swanky-spoon-society.jpg" },
  { name: "Slovon Bakehouse", src: "/assets/brands/slovon-bakehouse.jpg" },
  { name: "Sakkath Bites", src: "/assets/brands/sakkath-bites.jpg" },
  { name: "Doughpamine Kitchen", src: "/assets/brands/doughpamine-kitchen.jpg" },
  { name: "Wrap O'Clock", src: "/assets/brands/wrap-oclock.jpg" },
  { name: "ChaatGPT", src: "https://framerusercontent.com/images/ldpx9tzuPb6WsZqvCtvIPfdE.png" },
  { name: "Al Mashawi Shawarma", src: "/assets/brands/al-mashawi.jpg" },
  { name: "Chicbun", src: "https://framerusercontent.com/images/p1wTLLfubnUQuu4APjqi1ZVY.png" },
  { name: "Kritunga", src: "/assets/brands/kritunga.jpg" },
  { name: "Saladeo", src: "https://framerusercontent.com/images/rZn5uXcQC7dulzO5jaOj6Kt1HFY.png" },
  { name: "Skope Café", src: "https://framerusercontent.com/images/iqrcXcAXmVzlCSPyFwoR2i8Eak.png" },
];

const BrandMarquee = () => (
  <div className="relative bg-white border-b border-ink/10 py-8 overflow-hidden" data-testid="brand-marquee">
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12 mb-6 flex items-center gap-3 font-mono text-[10px] tracking-[0.35em] text-ink/40 uppercase">
      <span className="w-1.5 h-1.5 rounded-full bg-skope" />
      Powering {LOGOS.length} food brands — and counting
    </div>
    <div className="flex w-max animate-marquee">
      {[0, 1].map((half) => (
        <div key={half} className="flex shrink-0" aria-hidden={half === 1}>
          {LOGOS.map((logo, i) => (
            <div key={`${half}-${i}`} className="flex items-center justify-center w-44 h-24 mx-4 shrink-0 grayscale hover:grayscale-0 transition-all duration-500">
              <img src={logo.src} alt={`${logo.name} logo`} loading="lazy"
                className="max-w-full max-h-full object-contain"
                onError={(e) => { e.currentTarget.parentElement.style.display = "none"; }} />
            </div>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default BrandMarquee;
